module.exports = __webpack_public_path__ + "static/boat-0cc99fa8a604e811326d4da0992c7206.png";